<template>
  <div class="mt-4">
    <v-divider />
    <div class="mt-3"></div>
    <v-layout row wrap>
      <v-flex xs6>
        <toggle-button
          :value="followUp.follow_up_status"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          @change="onFollowUpStatusChanged"
          style="display: inline-block"
          :disabled="!isAdvancedPackage"
        />
        {{ $t('zerva.follow_up_label') }}
        <v-premium-lock
          v-if="!isAdvancedPackage"
          :inline="true"
          :text="$t('Upgrade to {package} Plan', { package: $t('ADVANCED') })"
          style="top: -10px"
        />
        <a href="https://blog.zwiz.app/notify-follow-up-zerva/" target="_blank" rel="noopener">
          <i style="font-size: 18px; color: #ed1e79;" class="ml-1 fas fa-question-circle"> </i>
        </a>
      </v-flex>
      <v-flex xs6 text-xs-right v-if="followUp.follow_up_status">
        <v-btn
          fab
          outline
          color="primary"
          class="extra-small ma-1"
          v-if="!isEdit"
          @click="isEdit = true"
        >
          <i class="fas fa-pencil-alt"></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="mt-3" v-if="followUp.follow_up_status">
      <div style="display: flex; justify-content: flex-end;" v-if="isEdit">
        <v-btn class="ma-0 extra-small" fab flat icon color="grey" @click="showSetting = true">
          <v-icon>settings</v-icon>
        </v-btn>
      </div>
      <div class="mt-2 d-flex">
        <channel-tab
          v-if="isSeparateByChannel"
          :tab="channelTab"
          @onChange="onChangeChannelTab"
          style="margin-top: 24px;"
        />
        <div class="form-control mt-2" style="width: 100%;">
          <textarea
            ref="textarea"
            v-model="followUpText"
            rows="6"
            maxlength="2000"
            :disabled="!isEdit"
            style="margin: unset;"
          />
          <div v-if="isEdit" style="display: flex; justify-content: flex-end;">
            {{ followUpText.length }} / 2000
          </div>
        </div>
        <v-menu offset-y open-on-hover v-if="isEdit">
          <template v-slot:activator="{ on }">
            <v-btn fab small outline class="ml-1 extra-small" color="primary" v-on="on">
              <span class="fas fa-ellipsis-v"></span>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(prefill, index) in prefills"
              :key="index"
              @click="insertPrefill(prefill.value)"
            >
              <v-list-tile-title class="primary-color"
                >{{ $t('Insert') }}{{ $t(prefill.label) }}</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <div>
        <div class="small mt-3 mb-2">{{ $t('Choice') }}</div>
        <template v-if="isEdit">
          <tags
            :tags="quickReplies"
            @tags-changed="addQuickReply"
            @before-adding-tag="checkQuickReply"
            :btnText="$t('Add choice')"
          ></tags>
          <div class="form-control has-error">
            <div v-for="(error, i) in errorTags" :key="i">
              <span class="text-error">
                {{ error }}
              </span>
              <br />
            </div>
          </div>
        </template>
        <ul class="tags" v-else-if="quickReplies.length">
          <li class="tag" v-for="(quickReply, index) in quickReplies" :key="'quickReply_' + index">
            {{ quickReply.text }}
          </li>
        </ul>
        <p v-else>-</p>
      </div>

      <div>
        <div class="small mt-3 black--text subheading">
          {{ $t('zerva.follow_up_within_label') }}
        </div>
        <div class="my-2" style="display: grid;">
          <span>{{ $t('Remark') }}</span>
          <span v-if="!isSeparateByChannel || (isSeparateByChannel && channelTab === 'facebook')">{{
            $t('zerva.remark.fb')
          }}</span>
          <span v-if="!isSeparateByChannel || (isSeparateByChannel && channelTab === 'line')">{{
            $t('zerva.remark.line')
          }}</span>
        </div>
        <zerva-connect-day-time-picker
          v-model="followUp.follow_up_within_minutes"
          :isEdit="isEdit"
        />
      </div>

      <div class="mt-4" style="display: flex; justify-content: center;" v-if="isEdit">
        <v-btn color="primary" outline @click="onCancel">
          ยกเลิก
        </v-btn>
        <v-btn color="primary" @click="onSave">
          ยืนยัน
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="showSetting" max-width="800" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn @click="showSetting = false" small fab flat><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text class="text-xs-left">
          <div class="primary--text">
            {{ $t('Reply Setting') }}
          </div>

          <v-radio-group
            v-model="isSeparateByChannel"
            hide-details
            row
            :disabled="!check_privilege('multichannel')"
          >
            <v-radio
              :label="$t('Same Reply to all Channels')"
              :value="false"
              color="primary"
            ></v-radio>
            <v-radio :label="$t('Seperate Reply')" :value="true" color="primary"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="saveSetting" color="primary">
            {{ $t('Save') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import ChannelTab from '@/components/elements/ChannelTab'
import Tags from '@/components/elements/Tags'
import TimePicker from '@/components/elements/TimePicker'
import DatePicker from '@/components/elements/DatePicker'
import ZervaConnectDayTimePicker from './ZervaConnectDayTimePicker'
import { safeParseJSON } from '@/utils/func'
import dayjs from 'dayjs'

export default {
  components: {
    ToggleButton,
    ChannelTab,
    Tags,
    TimePicker,
    DatePicker,
    ZervaConnectDayTimePicker
  },
  data() {
    return {
      followUp: {
        follow_up_status: false,
        follow_up_within_minutes: null,
        follow_up_val: null,
        follow_up_quick_reply: null,
        follow_up_fb_val: null,
        follow_up_fb_quick_reply: null,
        follow_up_line_val: null,
        follow_up_line_quick_reply: null,
        follow_up_ig_val: null,
        follow_up_ig_quick_reply: null,
        follow_up_google_val: null,
        follow_up_google_quick_reply: null,
        follow_up_whatsapp_val: null,
        follow_up_whatsapp_quick_reply: null
      },
      errorTags: [],
      showSetting: false,
      isEdit: false,
      isSeparateByChannel: false,
      channelTab: 'facebook',
      prefills: [
        {
          label: 'name',
          value: 'name'
        },
        {
          label: 'Email',
          value: 'email'
        },
        {
          label: 'Phone',
          value: 'phone_number'
        },
        {
          label: 'zerva.main_service_name',
          value: 'main_service_name'
        },
        {
          label: 'zerva.sub_service_name',
          value: 'sub_service_name'
        },
        {
          label: 'zerva.service_date',
          value: 'service_date'
        },
        {
          label: 'zerva.reservation_note',
          value: 'reservation_note'
        }
      ],
      updateTimestamp: dayjs().format('x') // This variable is used to re-render the time picker
    }
  },
  async mounted() {
    await this.getZervaFollowUp()
  },
  methods: {
    async getZervaFollowUp() {
      if (this.isAdvancedPackage) {
        try {
          this.$store.dispatch('loading')

          const { result } = await this.get(`page/${this.selectedBot.pageid}/zerva-follow-up`)
          this.followUp = result

          const {
            follow_up_fb_val: fbValue,
            follow_up_line_val: lineValue,
            follow_up_ig_val: igValue,
            follow_up_google_val: googleValue,
            follow_up_whatsapp_val: whatsappValue
          } = this.followUp

          if (fbValue || lineValue || igValue || googleValue || whatsappValue) {
            this.isSeparateByChannel = true
          }
        } finally {
          this.$store.dispatch('loading')
        }
      }
    },
    async onFollowUpStatusChanged({ value }) {
      this.followUp.follow_up_status = value

      try {
        this.$store.dispatch('loading')

        await this.patch(`page/${this.selectedBot.pageid}/zerva-follow-up`, {
          follow_up_status: value
        })
      } catch (err) {
        this.$swal({
          type: 'error',
          title: this.$t('Error'),
          text: err.message
        })
      } finally {
        this.$store.dispatch('loading')
      }
    },
    insertPrefill(value) {
      const cursorIndex = this.$refs.textarea.selectionStart
      this.followUpText =
        this.followUpText.slice(0, cursorIndex) +
        `{${value}}` +
        this.followUpText.slice(cursorIndex)
    },
    onChangeChannelTab(channel) {
      this.channelTab = channel
    },
    addQuickReply: function(newTags) {
      const tags = newTags.map(tag => tag.text).join(',')

      if (this.isSeparateByChannel) {
        if (this.channelTab == 'facebook') {
          this.followUp.follow_up_fb_quick_reply = tags
        } else if (this.channelTab == 'line') {
          this.followUp.follow_up_line_quick_reply = tags
        } else if (this.channelTab == 'instagram') {
          this.followUp.follow_up_ig_quick_reply = tags
        } else if (this.channelTab == 'google') {
          this.followUp.follow_up_google_quick_reply = tags
        } else if (this.channelTab == 'whatsapp') {
          this.followUp.follow_up_whatsapp_quick_reply = tags
        }
      } else {
        this.followUp.follow_up_quick_reply = tags
      }
    },
    checkQuickReply(obj) {
      this.errorTags = []

      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        this.errorTags.push(this.$t('Message cannot be longer than 20 alphabets'))
        obj.error()
      } else if (obj.type == 'add' && this.quickReplies.length >= 10) {
        this.errorTags.push(this.$t('Choices cannot be more than 10 items'))
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTags.push(this.$t('Duplicate Choice'))
        obj.error()
      } else obj.addTag()
    },
    formatValue(value) {
      return JSON.stringify([
        [
          {
            text: value,
            type: 'text'
          }
        ]
      ])
    },
    saveSetting() {
      if (this.isSeparateByChannel) {
        this.followUp = {
          ...this.followUp,
          follow_up_fb_val: this.followUp.follow_up_val,
          follow_up_fb_quick_reply: this.followUp.follow_up_quick_reply,
          follow_up_line_val: this.followUp.follow_up_val,
          follow_up_line_quick_reply: this.followUp.follow_up_quick_reply,
          follow_up_ig_val: this.followUp.follow_up_val,
          follow_up_ig_quick_reply: this.followUp.follow_up_quick_reply,
          follow_up_google_val: this.followUp.follow_up_val,
          follow_up_google_quick_reply: this.followUp.follow_up_quick_reply,
          follow_up_whatsapp_val: this.followUp.follow_up_val,
          follow_up_whatsapp_quick_reply: this.followUp.follow_up_quick_reply
        }
      }

      this.showSetting = false
    },
    async onSave() {
      try {
        this.$store.dispatch('loading')

        if (!this.isSeparateByChannel) {
          this.followUp = {
            ...this.followUp,
            follow_up_fb_val: null,
            follow_up_fb_quick_reply: null,
            follow_up_line_val: null,
            follow_up_line_quick_reply: null,
            follow_up_ig_val: null,
            follow_up_ig_quick_reply: null,
            follow_up_google_val: null,
            follow_up_google_quick_reply: null,
            follow_up_whatsapp_val: null,
            follow_up_whatsapp_quick_reply: null
          }
        }

        await this.patch(`page/${this.selectedBot.pageid}/zerva-follow-up`, this.followUp)

        this.isEdit = false
      } catch (err) {
        this.$swal({
          type: 'error',
          title: this.$t('Error'),
          text: err.message
        })
      } finally {
        this.$store.dispatch('loading')
      }
    },
    async onCancel() {
      this.isEdit = false
      await this.getZervaFollowUp()
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isAdvancedPackage() {
      return this.selectedBot.advancedExpriedDate > 0
    },
    followUpText: {
      get() {
        const {
          follow_up_val: value,
          follow_up_fb_val: fbValue,
          follow_up_line_val: lineValue,
          follow_up_ig_val: igValue,
          follow_up_google_val: googleValue,
          follow_up_whatsapp_val: whatsappValue
        } = this.followUp

        if (this.isSeparateByChannel) {
          if (this.channelTab === 'facebook') {
            const followUpFbValue = safeParseJSON(fbValue)

            return followUpFbValue ? followUpFbValue[0][0]['text'] : ''
          } else if (this.channelTab === 'line') {
            const followUpLineValue = safeParseJSON(lineValue)

            return followUpLineValue ? followUpLineValue[0][0]['text'] : ''
          } else if (this.channelTab === 'instagram') {
            const followUpIGValue = safeParseJSON(igValue)

            return followUpIGValue ? followUpIGValue[0][0]['text'] : ''
          } else if (this.channelTab === 'google') {
            const followUpGoogleValue = safeParseJSON(googleValue)

            return followUpGoogleValue ? followUpGoogleValue[0][0]['text'] : ''
          } else if (this.channelTab === 'whatsapp') {
            const followUpWhatsAppValue = safeParseJSON(whatsappValue)

            return followUpWhatsAppValue ? followUpWhatsAppValue[0][0]['text'] : ''
          }
        } else {
          const followUpValue = safeParseJSON(value)
          return followUpValue ? followUpValue[0][0]['text'] : ''
        }

        return ''
      },
      set(value) {
        if (this.isSeparateByChannel) {
          if (this.channelTab === 'facebook') {
            this.followUp.follow_up_fb_val = this.formatValue(value)
          } else if (this.channelTab === 'line') {
            this.followUp.follow_up_line_val = this.formatValue(value)
          } else if (this.channelTab === 'instagram') {
            this.followUp.follow_up_ig_val = this.formatValue(value)
          } else if (this.channelTab === 'google') {
            this.followUp.follow_up_google_val = this.formatValue(value)
          } else if (this.channelTab === 'whatsapp') {
            this.followUp.follow_up_whatsapp_val = this.formatValue(value)
          }
        } else {
          this.followUp.follow_up_val = this.formatValue(value)
        }
      }
    },
    quickReplies() {
      let quickReplies

      if (this.isSeparateByChannel) {
        if (this.channelTab === 'facebook') {
          quickReplies = this.followUp.follow_up_fb_quick_reply
        } else if (this.channelTab === 'line') {
          quickReplies = this.followUp.follow_up_line_quick_reply
        } else if (this.channelTab === 'instagram') {
          quickReplies = this.followUp.follow_up_ig_quick_reply
        } else if (this.channelTab === 'google') {
          quickReplies = this.followUp.follow_up_google_quick_reply
        } else if (this.channelTab === 'whatsapp') {
          quickReplies = this.followUp.follow_up_whatsapp_quick_reply
        }
      } else {
        quickReplies = this.followUp.follow_up_quick_reply
      }

      if (!quickReplies) return []

      return quickReplies.split(',').map(reply => ({ text: reply }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ZervaConnect/ZervaConnectFollowUp.vue